export default __webpack_public_path__ + "static/media/youtube.55d9106a.svg";